import axios from 'axios';
import config from '../utils/config';

const { COVE_API_V4_URL } = config;

const onError = (error) => error;

const getHeaders = (headers) => ({
  'content-type': 'application/json',
  ...headers,
});

/**
 *
 * @param {object} params
 * @param {'GET' | 'POST' | 'PUT' | 'OPTION' | 'DELETE'} params.method
 * @param {string} params.url
 * @param {object} params.body
 * @param {object=} params.headers
 * @returns
 */
export const apiV4 = ({ method, url, body, headers }) =>
  axios
    .request({
      baseURL: COVE_API_V4_URL,
      method,
      url,
      data: body,
      headers: getHeaders(headers),
    })
    .catch(onError);
